import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { CookiesProvider } from 'react-cookie'
import { ErrorBoundary } from 'react-error-boundary'
import { BaseProvider } from '@telus-uds/components-web'
import alliumTheme from '@telus-uds/theme-allium'
import { clients, contexts, components } from '@digital-commerce/shared-utils'
import { LocaleProvider, LocaleConsumer } from './contexts/Locale'
import { TranslationProvider } from './contexts/Translation'
import Cart from './Container'
import ErrorFallback from './components/organisms/ErrorFallback'
import translations from './locales'
import initAlloyAnalytics from './utils/alloyAnalytics'
import { GlobalStyleOverride } from './styles'

initAlloyAnalytics()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false
    }
  }
})
const App = () => {
  return (
    <>
      <GlobalStyleOverride />
      <BaseProvider defaultTheme={alliumTheme}>
        <CookiesProvider>
          <LocaleProvider>
            <contexts.ContentfulClientProvider
              value={{
                contentfulClient: clients.contentful.client,
                contentfulLegalClient: clients.contentful.legalClient
              }}
            >
              <QueryClientProvider client={queryClient}>
                <ErrorBoundary FallbackComponent={ErrorFallback}>
                  <ReactQueryDevtools initialIsOpen={false} />
                  <LocaleConsumer>
                    {(locale) => {
                      return (
                        <contexts.LegalProvider>
                          <TranslationProvider translations={translations}>
                            <Cart />
                          </TranslationProvider>
                          <components.LegalList locale={locale} />
                        </contexts.LegalProvider>
                      )
                    }}
                  </LocaleConsumer>
                </ErrorBoundary>
              </QueryClientProvider>
            </contexts.ContentfulClientProvider>
          </LocaleProvider>
        </CookiesProvider>
      </BaseProvider>
    </>
  )
}

export default App
